// extracted by mini-css-extract-plugin
module.exports =  {"zoom-buttons":"_2787e5dfdf--zoom-buttons--jFxom","zoom-plus":"_2787e5dfdf--zoom-plus--ESIHl","zoom-minus":"_2787e5dfdf--zoom-minus--KafK2","icon":"_2787e5dfdf--icon--RUpqd"};